"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/internal_common.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalGoods = exports.InternalGoodsVariant_File = exports.InternalGoodsVariant = exports.InternalGoodsVariantDigitalImage = exports.InternalGoodsImage = exports.InternalGoodsShippingSettingMadeToStock = exports.InternalGoodsShippingSettingMadeToOrder = exports.InternalGoodsSelfShipping = exports.InternalGoodsDigital = exports.InternalGoodsPurchaseStatus = exports.InternalGoodsStatus = exports.InternalGoodsType = exports.InternalGoodsVariantDigitalType = exports.InternalInventoryPolicy = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.goods.v1.InternalInventoryPolicy
 */
var InternalInventoryPolicy;
(function (InternalInventoryPolicy) {
    /**
     * @generated from enum value: INTERNAL_INVENTORY_POLICY_UNSPECIFIED = 0;
     */
    InternalInventoryPolicy[InternalInventoryPolicy["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 在庫がなくなった場合、購入を拒否する
     *
     * @generated from enum value: INTERNAL_INVENTORY_POLICY_DENY = 1;
     */
    InternalInventoryPolicy[InternalInventoryPolicy["DENY"] = 1] = "DENY";
    /**
     * 在庫がなくなった場合、購入を続けることができる
     *
     * @generated from enum value: INTERNAL_INVENTORY_POLICY_CONTINUE = 2;
     */
    InternalInventoryPolicy[InternalInventoryPolicy["CONTINUE"] = 2] = "CONTINUE";
})(InternalInventoryPolicy || (exports.InternalInventoryPolicy = InternalInventoryPolicy = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalInventoryPolicy)
protobuf_1.proto3.util.setEnumType(InternalInventoryPolicy, "spwn.goods.v1.InternalInventoryPolicy", [
    { no: 0, name: "INTERNAL_INVENTORY_POLICY_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_INVENTORY_POLICY_DENY" },
    { no: 2, name: "INTERNAL_INVENTORY_POLICY_CONTINUE" },
]);
/**
 * @generated from enum spwn.goods.v1.InternalGoodsVariantDigitalType
 */
var InternalGoodsVariantDigitalType;
(function (InternalGoodsVariantDigitalType) {
    /**
     * @generated from enum value: INTERNAL_GOODS_VARIANT_DIGITAL_TYPE_UNSPECIFIED = 0;
     */
    InternalGoodsVariantDigitalType[InternalGoodsVariantDigitalType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: INTERNAL_GOODS_VARIANT_DIGITAL_TYPE_DIGITAL = 1;
     */
    InternalGoodsVariantDigitalType[InternalGoodsVariantDigitalType["DIGITAL"] = 1] = "DIGITAL";
})(InternalGoodsVariantDigitalType || (exports.InternalGoodsVariantDigitalType = InternalGoodsVariantDigitalType = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalGoodsVariantDigitalType)
protobuf_1.proto3.util.setEnumType(InternalGoodsVariantDigitalType, "spwn.goods.v1.InternalGoodsVariantDigitalType", [
    { no: 0, name: "INTERNAL_GOODS_VARIANT_DIGITAL_TYPE_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_GOODS_VARIANT_DIGITAL_TYPE_DIGITAL" },
]);
/**
 * @generated from enum spwn.goods.v1.InternalGoodsType
 */
var InternalGoodsType;
(function (InternalGoodsType) {
    /**
     * @generated from enum value: INTERNAL_GOODS_TYPE_UNSPECIFIED = 0;
     */
    InternalGoodsType[InternalGoodsType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: INTERNAL_GOODS_TYPE_DIGITAL = 1;
     */
    InternalGoodsType[InternalGoodsType["DIGITAL"] = 1] = "DIGITAL";
    /**
     * @generated from enum value: INTERNAL_GOODS_TYPE_SELF_SHIPPING = 2;
     */
    InternalGoodsType[InternalGoodsType["SELF_SHIPPING"] = 2] = "SELF_SHIPPING";
})(InternalGoodsType || (exports.InternalGoodsType = InternalGoodsType = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalGoodsType)
protobuf_1.proto3.util.setEnumType(InternalGoodsType, "spwn.goods.v1.InternalGoodsType", [
    { no: 0, name: "INTERNAL_GOODS_TYPE_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_GOODS_TYPE_DIGITAL" },
    { no: 2, name: "INTERNAL_GOODS_TYPE_SELF_SHIPPING" },
]);
/**
 * @generated from enum spwn.goods.v1.InternalGoodsStatus
 */
var InternalGoodsStatus;
(function (InternalGoodsStatus) {
    /**
     * @generated from enum value: INTERNAL_GOODS_STATUS_UNSPECIFIED = 0;
     */
    InternalGoodsStatus[InternalGoodsStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 公開
     *
     * @generated from enum value: INTERNAL_GOODS_STATUS_ACTIVE = 1;
     */
    InternalGoodsStatus[InternalGoodsStatus["ACTIVE"] = 1] = "ACTIVE";
    /**
     * 準備中
     *
     * @generated from enum value: INTERNAL_GOODS_STATUS_DRAFT = 2;
     */
    InternalGoodsStatus[InternalGoodsStatus["DRAFT"] = 2] = "DRAFT";
    /**
     * アーカイブ
     *
     * @generated from enum value: INTERNAL_GOODS_STATUS_ARCHIVED = 3;
     */
    InternalGoodsStatus[InternalGoodsStatus["ARCHIVED"] = 3] = "ARCHIVED";
})(InternalGoodsStatus || (exports.InternalGoodsStatus = InternalGoodsStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalGoodsStatus)
protobuf_1.proto3.util.setEnumType(InternalGoodsStatus, "spwn.goods.v1.InternalGoodsStatus", [
    { no: 0, name: "INTERNAL_GOODS_STATUS_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_GOODS_STATUS_ACTIVE" },
    { no: 2, name: "INTERNAL_GOODS_STATUS_DRAFT" },
    { no: 3, name: "INTERNAL_GOODS_STATUS_ARCHIVED" },
]);
/**
 * @generated from enum spwn.goods.v1.InternalGoodsPurchaseStatus
 */
var InternalGoodsPurchaseStatus;
(function (InternalGoodsPurchaseStatus) {
    /**
     * @generated from enum value: INTERNAL_GOODS_PURCHASE_STATUS_UNSPECIFIED = 0;
     */
    InternalGoodsPurchaseStatus[InternalGoodsPurchaseStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 購入可能
     *
     * @generated from enum value: INTERNAL_GOODS_PURCHASE_STATUS_PURCHASEABLE = 1;
     */
    InternalGoodsPurchaseStatus[InternalGoodsPurchaseStatus["PURCHASEABLE"] = 1] = "PURCHASEABLE";
    /**
     * 購入可能状態のグッズでない
     *
     * @generated from enum value: INTERNAL_GOODS_PURCHASE_STATUS_NOT_ACTIVE_GOODS = 2;
     */
    InternalGoodsPurchaseStatus[InternalGoodsPurchaseStatus["NOT_ACTIVE_GOODS"] = 2] = "NOT_ACTIVE_GOODS";
    /**
     * バリエーション全てが売り切れ
     *
     * @generated from enum value: INTERNAL_GOODS_PURCHASE_STATUS_SOLD_OUT = 3;
     */
    InternalGoodsPurchaseStatus[InternalGoodsPurchaseStatus["SOLD_OUT"] = 3] = "SOLD_OUT";
    /**
     * 販売期間前
     *
     * @generated from enum value: INTERNAL_GOODS_PURCHASE_STATUS_BEFORE_SALES_PERIOD = 4;
     */
    InternalGoodsPurchaseStatus[InternalGoodsPurchaseStatus["BEFORE_SALES_PERIOD"] = 4] = "BEFORE_SALES_PERIOD";
    /**
     * 販売期間終了
     *
     * @generated from enum value: INTERNAL_GOODS_PURCHASE_STATUS_AFTER_SALES_PERIOD = 5;
     */
    InternalGoodsPurchaseStatus[InternalGoodsPurchaseStatus["AFTER_SALES_PERIOD"] = 5] = "AFTER_SALES_PERIOD";
})(InternalGoodsPurchaseStatus || (exports.InternalGoodsPurchaseStatus = InternalGoodsPurchaseStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalGoodsPurchaseStatus)
protobuf_1.proto3.util.setEnumType(InternalGoodsPurchaseStatus, "spwn.goods.v1.InternalGoodsPurchaseStatus", [
    { no: 0, name: "INTERNAL_GOODS_PURCHASE_STATUS_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_GOODS_PURCHASE_STATUS_PURCHASEABLE" },
    { no: 2, name: "INTERNAL_GOODS_PURCHASE_STATUS_NOT_ACTIVE_GOODS" },
    { no: 3, name: "INTERNAL_GOODS_PURCHASE_STATUS_SOLD_OUT" },
    { no: 4, name: "INTERNAL_GOODS_PURCHASE_STATUS_BEFORE_SALES_PERIOD" },
    { no: 5, name: "INTERNAL_GOODS_PURCHASE_STATUS_AFTER_SALES_PERIOD" },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsDigital
 */
class InternalGoodsDigital extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 種別
         *
         * @generated from field: spwn.goods.v1.InternalGoodsType type = 2;
         */
        this.type = InternalGoodsType.UNSPECIFIED;
        /**
         * グッズ名
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 4;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 5;
         */
        this.price = 0;
        /**
         * グッズのイメージ画像
         *
         * @generated from field: repeated spwn.goods.v1.InternalGoodsImage images = 6;
         */
        this.images = [];
        /**
         * ブランドID
         *
         * @generated from field: string brand_id = 7;
         */
        this.brandId = "";
        /**
         * 公開設定が有効な場合、販売開始日の前にアクセス可能か
         *
         * @generated from field: bool enable_access_before_sales_period = 10;
         */
        this.enableAccessBeforeSalesPeriod = false;
        /**
         * グッズのステータス
         *
         * @generated from field: spwn.goods.v1.InternalGoodsStatus status = 11;
         */
        this.status = InternalGoodsStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsDigital().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsDigital().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsDigital().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsDigital, a, b);
    }
}
exports.InternalGoodsDigital = InternalGoodsDigital;
InternalGoodsDigital.runtime = protobuf_1.proto3;
InternalGoodsDigital.typeName = "spwn.goods.v1.InternalGoodsDigital";
InternalGoodsDigital.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalGoodsType) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "images", kind: "message", T: InternalGoodsImage, repeated: true },
    { no: 7, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "enable_access_before_sales_period", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalGoodsStatus) },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsSelfShipping
 */
class InternalGoodsSelfShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 種別
         *
         * @generated from field: spwn.goods.v1.InternalGoodsType type = 2;
         */
        this.type = InternalGoodsType.UNSPECIFIED;
        /**
         * グッズ名
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 4;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 5;
         */
        this.price = 0;
        /**
         * グッズのイメージ画像
         *
         * @generated from field: repeated spwn.goods.v1.InternalGoodsImage images = 6;
         */
        this.images = [];
        /**
         * ブランドID
         *
         * @generated from field: string brand_id = 7;
         */
        this.brandId = "";
        /**
         * 公開設定が有効な場合、販売開始日の前にアクセス可能か
         *
         * @generated from field: bool enable_access_before_sales_period = 10;
         */
        this.enableAccessBeforeSalesPeriod = false;
        /**
         * グッズのステータス
         *
         * @generated from field: spwn.goods.v1.InternalGoodsStatus status = 11;
         */
        this.status = InternalGoodsStatus.UNSPECIFIED;
        /**
         * 発送設定 // TODO: ここの構造は検討してもいいかも
         *
         * @generated from oneof spwn.goods.v1.InternalGoodsSelfShipping.shipping_setting
         */
        this.shippingSetting = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsSelfShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsSelfShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsSelfShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsSelfShipping, a, b);
    }
}
exports.InternalGoodsSelfShipping = InternalGoodsSelfShipping;
InternalGoodsSelfShipping.runtime = protobuf_1.proto3;
InternalGoodsSelfShipping.typeName = "spwn.goods.v1.InternalGoodsSelfShipping";
InternalGoodsSelfShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalGoodsType) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "images", kind: "message", T: InternalGoodsImage, repeated: true },
    { no: 7, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "enable_access_before_sales_period", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalGoodsStatus) },
    { no: 12, name: "made_to_order", kind: "message", T: InternalGoodsShippingSettingMadeToOrder, oneof: "shipping_setting" },
    { no: 13, name: "made_to_stock", kind: "message", T: InternalGoodsShippingSettingMadeToStock, oneof: "shipping_setting" },
]);
/**
 * 受注生産の発送設定
 *
 * @generated from message spwn.goods.v1.InternalGoodsShippingSettingMadeToOrder
 */
class InternalGoodsShippingSettingMadeToOrder extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 送料
         *
         * @generated from field: double shipping_fee = 1;
         */
        this.shippingFee = 0;
        /**
         * 発送予定日
         *
         * @generated from field: int64 shipped_at = 2;
         */
        this.shippedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsShippingSettingMadeToOrder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsShippingSettingMadeToOrder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsShippingSettingMadeToOrder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsShippingSettingMadeToOrder, a, b);
    }
}
exports.InternalGoodsShippingSettingMadeToOrder = InternalGoodsShippingSettingMadeToOrder;
InternalGoodsShippingSettingMadeToOrder.runtime = protobuf_1.proto3;
InternalGoodsShippingSettingMadeToOrder.typeName = "spwn.goods.v1.InternalGoodsShippingSettingMadeToOrder";
InternalGoodsShippingSettingMadeToOrder.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "shipped_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * 見込み生産の発送設定
 *
 * @generated from message spwn.goods.v1.InternalGoodsShippingSettingMadeToStock
 */
class InternalGoodsShippingSettingMadeToStock extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 送料
         *
         * @generated from field: double shipping_fee = 1;
         */
        this.shippingFee = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsShippingSettingMadeToStock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsShippingSettingMadeToStock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsShippingSettingMadeToStock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsShippingSettingMadeToStock, a, b);
    }
}
exports.InternalGoodsShippingSettingMadeToStock = InternalGoodsShippingSettingMadeToStock;
InternalGoodsShippingSettingMadeToStock.runtime = protobuf_1.proto3;
InternalGoodsShippingSettingMadeToStock.typeName = "spwn.goods.v1.InternalGoodsShippingSettingMadeToStock";
InternalGoodsShippingSettingMadeToStock.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "min_days_to_ship", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "max_days_to_ship", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsImage
 */
class InternalGoodsImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズ画像のURL
         *
         * @generated from field: string src = 1;
         */
        this.src = "";
        /**
         * @generated from field: int32 position = 2;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsImage, a, b);
    }
}
exports.InternalGoodsImage = InternalGoodsImage;
InternalGoodsImage.runtime = protobuf_1.proto3;
InternalGoodsImage.typeName = "spwn.goods.v1.InternalGoodsImage";
InternalGoodsImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsVariantDigitalImage
 */
class InternalGoodsVariantDigitalImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string src = 1;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsVariantDigitalImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsVariantDigitalImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsVariantDigitalImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsVariantDigitalImage, a, b);
    }
}
exports.InternalGoodsVariantDigitalImage = InternalGoodsVariantDigitalImage;
InternalGoodsVariantDigitalImage.runtime = protobuf_1.proto3;
InternalGoodsVariantDigitalImage.typeName = "spwn.goods.v1.InternalGoodsVariantDigitalImage";
InternalGoodsVariantDigitalImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoodsVariant
 */
class InternalGoodsVariant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        /**
         * バリエーションの種別
         *
         * @generated from field: spwn.goods.v1.InternalGoodsVariantDigitalType type = 2;
         */
        this.type = InternalGoodsVariantDigitalType.UNSPECIFIED;
        /**
         * バリエーションの名前
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 5;
         */
        this.inventoryQuantity = 0;
        /**
         * 在庫数がなくなった場合の振る舞い
         *
         * @generated from field: spwn.goods.v1.InternalInventoryPolicy inventory_policy = 6;
         */
        this.inventoryPolicy = InternalInventoryPolicy.UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.goods.v1.InternalGoodsVariant.File files = 7;
         */
        this.files = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsVariant, a, b);
    }
}
exports.InternalGoodsVariant = InternalGoodsVariant;
InternalGoodsVariant.runtime = protobuf_1.proto3;
InternalGoodsVariant.typeName = "spwn.goods.v1.InternalGoodsVariant";
InternalGoodsVariant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalGoodsVariantDigitalType) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image", kind: "message", T: InternalGoodsVariantDigitalImage },
    { no: 5, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "inventory_policy", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalInventoryPolicy) },
    { no: 7, name: "files", kind: "message", T: InternalGoodsVariant_File, repeated: true },
]);
/**
 * ダウンロード可能なファイル
 *
 * @generated from message spwn.goods.v1.InternalGoodsVariant.File
 */
class InternalGoodsVariant_File extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        /**
         * @generated from field: string src = 2;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsVariant_File().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsVariant_File().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsVariant_File().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsVariant_File, a, b);
    }
}
exports.InternalGoodsVariant_File = InternalGoodsVariant_File;
InternalGoodsVariant_File.runtime = protobuf_1.proto3;
InternalGoodsVariant_File.typeName = "spwn.goods.v1.InternalGoodsVariant.File";
InternalGoodsVariant_File.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.InternalGoods
 */
class InternalGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.goods.v1.InternalGoods.data
         */
        this.data = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoods, a, b);
    }
}
exports.InternalGoods = InternalGoods;
InternalGoods.runtime = protobuf_1.proto3;
InternalGoods.typeName = "spwn.goods.v1.InternalGoods";
InternalGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "digital", kind: "message", T: InternalGoodsDigital, oneof: "data" },
    { no: 2, name: "self_shipping", kind: "message", T: InternalGoodsSelfShipping, oneof: "data" },
]);
//# sourceMappingURL=internal_common_pb.js.map